import { makeAutoObservable } from 'mobx'
import { mx } from 'store/base/mx'

export class Tele2QrModalStore {
  constructor() {
    makeAutoObservable(this)
  }
}

export const tele2QrModal = mx.ref<Tele2QrModalStore>()
